import FetchMock, { Middleware, MiddlewareUtils } from 'yet-another-fetch-mock';

import { hentSkademeldingUrl, hentUserUrl } from '../urler';
import { feilfyllingSporsmalsflyt } from './sporsmalsflyt';

/* eslint-disable no-console */
const loggingMiddleware: Middleware = (request, response) => {
    try {
        console.log('response', JSON.parse(response.body));
    } catch (e) {
        console.log('error', response);
    }

    console.groupEnd();
    return response;
};

console.log('#############');
console.log(' USING MOCKS');
console.log('#############');
/* eslint-enable no-console */

function randomDelayMiddleware(mean: number, range: number): Middleware {
    return (request, response) => {
        return new Promise((resolve) => {
            const delay = mean + 2 * range * Math.random() - range;
            setTimeout(() => resolve(response), delay);
        });
    };
}

const contentTypeMiddleware: Middleware = (requestArgs, response) => {
    if (response.headers) {
        return response;
    }
    response.headers = {
        'content-type': 'application/json',
    };
    return response;
};

const mock = FetchMock.configure({
    enableFallback: true,
    middleware: MiddlewareUtils.combine(randomDelayMiddleware(1000, 250), loggingMiddleware, contentTypeMiddleware),
});

mock.post(hentSkademeldingUrl(), (req, res, ctx) => res(ctx.status(204)));

mock.get(hentUserUrl(), (req, res, ctx) =>
    res(
        ctx.json({
            fornavn: 'fornavn',
            etternavn: 'etternavn',
            fodselsnummer: '22129247901',
            epost: 'test@test.no',
            mobilnummer: '47850875',
        }),
    ),
);

mock.get(`/meld-skade-web/rest/resource/skademelding/sporsmalsflyt`, (req, res, ctx) =>
    res(ctx.json(feilfyllingSporsmalsflyt)),
);
